import { CompassMark } from './CompassMark';

export function TrailCompassArtwork({ compact = false }: { compact?: boolean }) {
  return (
    <div
      className={compact ? 'trail-compass-artwork is-compact' : 'trail-compass-artwork'}
      aria-hidden="true"
    >
      <CompassMark />
    </div>
  );
}
